<template>
  <div class="admin-preview-banner" v-if="visible">
    <span class="banner-icon">&#9888;</span>
    <span class="banner-text">管理员预览模式 — 当前显示包含未发布的草稿数据，普通用户看不到此内容</span>
    <button class="banner-close" @click="$emit('close')" title="关闭提示">&times;</button>
  </div>
</template>

<script>
export default {
  name: 'AdminPreviewBanner',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close']
};
</script>

<style scoped>
.admin-preview-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%);
  border-bottom: 2px solid #ffc107;
  color: #664d03;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.banner-icon {
  font-size: 18px;
}

.banner-close {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  font-size: 20px;
  color: #664d03;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.banner-close:hover {
  opacity: 1;
}
</style>
